import types from '../types'

const initialState = {
  origin: '',
  destination: '',
  origLngName: '',
  destLngName: '',
  origShrtName: '',
  destShrtName: '',
}

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ORIGIN_CHANGE:
      return {
        ...state,
        origin: action.payload,
      }
    case types.DESTINATION_CHANGE:
      return {
        ...state,
        destination: action.payload,
      }
    case types.ORIGIN_LONGNAME_CHANGE:
      return {
        ...state,
        origLngName: action.payload,
      }
    case types.DESTINATION_LONGNAME_CHANGE:
      return {
        ...state,
        destLngName: action.payload,
      }
    case types.ORIGIN_SHORTNAME_CHANGE:
      return {
        ...state,
        origShrtName: action.payload,
      }
    case types.DESTINATION_SHORTNAME_CHANGE:
      return {
        ...state,
        destShrtName: action.payload,
      }
    case types.ORIGIN_GOOGLE_PLACE_ID_CHANGE:
      return {
        ...state,
        originGooglePlaceId: action.payload,
      }
    case types.DESTINATION_GOOGLE_PLACE_ID_CHANGE:
      return {
        ...state,
        destinationGooglePlaceId: action.payload,
      }
    default:
      return state
  }
}

export default locationReducer
